import React, { useEffect, useState } from 'react';
import {
  fetchTemplateDetails,
  fetchDynamicTemplateFields,
  updateTemplate,
  createTemplate,
} from '../services/template_services';
import ContractModelForm from '../../app/components/ContractModelForm';
import DataForm from '../components/DataForm';
import FormikInput from '../components/formik/FormikInput';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import ButtonAuth from '../components/ButtonAuth';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';

const TemplatePage = () => {
  const { id } = useParams();
  const [templateDetails, setTemplateDetails] = useState();
  const [dynamicFields, setDynamicFields] = useState([]);

  const history = useHistory();

  useEffect(() => {
    if (id) {
      fetchTemplateDetails(id).then((res) => setTemplateDetails(res));
    }
    fetchDynamicTemplateFields().then((res) => setDynamicFields(res));
  }, []);

  const handleSubmit = (values) => {
    if (id) {
      updateTemplate(id, values).then(() => {
        toast.success('Template atualizado com sucesso!');
      })
      .catch((err) => toast.error(err));
    } else {
      createTemplate(values).then(() => {
        toast.success('Template criado com sucesso!');
      })
      .catch((err) => toast.error(err));
    }
    history.push('/templates');
  };

  return id && !templateDetails ? (
    <Skeleton width="100%" height={400} />
  ) : (
    <div className="container">
      <div className="d-flex align-items-center position-relative mt-3">
        <h2 style={{ fontSize: '1.35rem' }}>
          {id ? 'Editar' : 'Novo'} Template
        </h2>
      </div>
      <div className="card m-3" style={styles.card_style}>
        <DataForm
          autoSetErrors
          onSubmit={(values) => handleSubmit(values)}
          initialValues={templateDetails || { contract_body: '' }}
        >
          {(formik) => (
            <>
              <FormikInput name="title" label="Título" />
              <FormikInput name="description" label="Descrição" />
              <ContractModelForm formik={formik} options={dynamicFields} />
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <ButtonAuth
                  style={{
                    marginTop: '10px',
                    height: '30px',
                    width: '20%',
                    padding: '0px',
                  }}
                  type="button"
                  onClick={() => history.push('/templates')}
                >
                  Voltar
                </ButtonAuth>
                <ButtonAuth
                  style={{
                    marginTop: '10px',
                    height: '30px',
                    width: '20%',
                    padding: '0px',
                  }}
                  type="submit"
                >
                  Salvar
                </ButtonAuth>
              </div>
            </>
          )}
        </DataForm>
      </div>
    </div>
  );
};

export default TemplatePage;

const styles = {
  card_style: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'auto',
    padding: '12px',
  },
};
